import { render, staticRenderFns } from "./Tx_Mny.vue?vue&type=template&id=2df0580e&scoped=true"
import script from "./Tx_Mny.vue?vue&type=script&lang=js"
export * from "./Tx_Mny.vue?vue&type=script&lang=js"
import style0 from "./Tx_Mny.vue?vue&type=style&index=0&id=2df0580e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0580e",
  null
  
)

export default component.exports